// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    logoAlt: 'Иконка Звездных войн',
    navLinks: {
      home: 'Главная',
      people: 'Персонажи',
      search: 'Поиск',
      notFound: 'Страница не найдена',
    },
    headerText: {
      choose: 'Выбери свою сторону',
      search: 'Поиск',
      favorites: 'Избранные',
    },
    chooseSide: {
      light: 'Светлая сторона',
      dark: 'Темная сторона',
      neutral: 'Нейтральная',
    },
    listNavButtons: {
      prev: 'Пред.',
      next: 'След.',
    },
    searchInputPlaceholder: 'Введите имя персонажа',
    goBackLink: 'Назад',
    personInfo: {
      height: 'Рост',
      mass: 'Вес',
      gender: 'Пол',
      birthYear: 'Год рождения',
      hairColor: 'Цвет волос',
      skinColor: 'Цвет кожи',
      eyeColor: ' Цвет глаз',
    },
    episode: 'Епизод {{number}}',
    errors: {
      noDataMessage: 'Данные отсутствуют',
      noMatchUrl: 'Нет совподений по запросу',
      fetchMessage: 'Темная сторона победила.\nМы не можем отобразить данные.\nПопробуйте повторить попытку позже\nкогда мы все починим.'
    },
  },
};